import {ChangeDetectorRef, Component, forwardRef, Input, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

/**
 * The equivalent value is used to set the model on selection of the
 * radio control. The name is used to content-layout part of the id to group
 * but make each control unique within the group. Each radio button needs to
 * share the same name (to group them), a different ID (to seperate them),
 * and an assign value (that's gets set when truthy).
 */
@Component({
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FUIRadioControlComponent),
        multi: true
    }],
    selector: "fui-radio-control",
    templateUrl: "./radio-control.component.html",
})
export class FUIRadioControlComponent extends FUIAbstractControl {
    @Input() public equivalent: any;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
